import PropTypes from 'prop-types';
import { format } from 'date-fns';
import {
  Avatar,
  Box,
  Card,
  Checkbox,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from '@mui/material';
import { Scrollbar } from 'src/components/scrollbar';
import { getInitials } from 'src/utils/get-initials';
import { useState } from 'react';
import PopupMessage from 'src/utils/PopUpMessage';
import RiderDetail from 'src/pages/rider/rider-detail';
import RiderDocument from 'src/pages/rider/rider-document';
import ConfirmDialog from 'src/pages/rider/ConfirmDialog';
import dashboardService from 'src/services/dashboardService';

export const RidersTable = (props) => {

  const {
    count = 0,
    items = [],
    onDeselectAll,
    onDeselectOne,
    onPageChange = () => { },
    onRowsPerPageChange,
    onSelectAll,
    onSelectOne,

    selected = []
  } = props;

  const selectedSome = (selected.length > 0) && (selected.length < items.length);
  const selectedAll = (items.length > 0) && (selected.length === items.length);

  const [showPopup, setShowPopup] = useState(false);
  const [isViewRiderDetailOpen, setIsViewRiderDetailOpen] = useState(false);
  const [isReviewRiderDocumentOpen, setIsReviewRiderDocumentOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [riderId, setRiderId] = useState();
  const [documentId, setDocumentId] = useState();
  const [isYesNoDialogOpen, setIsYesNoDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const riderDetail = (riderId) => {
    setRiderId(riderId);
    setIsViewRiderDetailOpen(!isViewRiderDetailOpen);
    // router.push(`rider/rider-detail?riderId=${riderId}`);
  }

  const documentDetail = (rider) => {
    if (rider.document_image != null && rider.document_image.id != null) {
      setDocumentId(rider.document_image.id);
      // router.push(`rider/rider-document?documentId=${rider.document_image.id}`);
      setIsReviewRiderDocumentOpen(!isReviewRiderDocumentOpen);
    } else {
      setPopupMessage("No document found");
      setShowPopup(!showPopup);
    }

  }
  const openPopup = (message) => {
    setPopupMessage(message);
    setShowPopup(!showPopup);
  };

  const riderDetails = () => {
    setIsViewRiderDetailOpen(!isViewRiderDetailOpen);
  }
  const documentDetails = () => {
    setIsReviewRiderDocumentOpen(!isReviewRiderDocumentOpen);
  }
  const deleteRider = (riderId) => {
    setErrorMessage("");
    setRiderId(riderId);
    setIsYesNoDialogOpen(!isYesNoDialogOpen);

    // router.push(`customer/customer-detail?customerId=${customerId}`);
  }
  const deleteUser = () => {
    dashboardService.deleteRider(riderId)
      .then((res) => {
        if (res.status == 200) {

          window.location.reload();
        }
      }).catch((error) => {
        setErrorMessage("Something went wrong");
      })
  }
  return (
    <Card>
    <div className="overflow-x-auto">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  S.N
                </TableCell>
                <TableCell>
                  Name
                </TableCell>
                <TableCell>
                  Email
                </TableCell>
                <TableCell>
                  Is Document Verified
                </TableCell>
                <TableCell>
                  Email
                </TableCell>
                <TableCell>
                  Phone Number
                </TableCell>
                <TableCell>
                  Created Date
                </TableCell>
                <TableCell>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((rider, index) => {
                const isSelected = selected.includes(rider.id);
                const createdAt = format(new Date(rider.created_at), 'dd/MM/yyyy');
                return (
                  <TableRow
                    hover
                    key={rider.id}
                    selected={isSelected}
                  >
                    <TableCell>
                      {index+1}
                    </TableCell>
                    <TableCell>
                      {rider.full_name}
                    </TableCell>
                    <TableCell>
                      {rider.email}
                    </TableCell>
                    <TableCell>
                      {rider.document_image != null && rider.document_image.is_valid_document === 1 ? (
                        <div className="text-green-500">
                          <img
                            src={rider.is_email_verified || "/assets/images/approved.png"}
                            alt="Verified"
                            className="w-20 h-20 rounded-full border-4 border-blue-500"
                          />
                          <p className="mt-2">Verified</p>
                        </div>

                      ) : (
                        <div className="text-red-500">
                          <img
                            src="/assets/images/delete-button.png"
                            alt="Not Verified"
                            className="w-20 h-20 rounded-full border-4 border-red-500"
                          />
                          <p className="mt-2">Not Verified</p>
                        </div>
                      )}
                    </TableCell>
                    <TableCell>
                      {rider.email}
                    </TableCell>
                    <TableCell>
                      {rider.phone_number}
                    </TableCell>
                    <TableCell>
                      {createdAt}
                    </TableCell>
                    <TableCell>
                      <div className="flex">
                        <button
                          className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded mr-2"
                          onClick={() => riderDetail(rider.id)}
                        >
                          View
                        </button>
                        <button
                          className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded mr-2"
                          onClick={() => documentDetail(rider)}
                        >
                          Review Document
                        </button>
                        <button
                          className="bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded mr-2"
                          onClick={() => deleteRider(rider.id)}
                        >
                          Delete
                        </button>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          </div>
      {
        isViewRiderDetailOpen && (
          <RiderDetail riderId={riderId} isOpen={isViewRiderDetailOpen} onClose={riderDetails} />
        )
      }
      {showPopup && (
        <PopupMessage message={popupMessage} onClose={openPopup} />
      )}

      {
        isReviewRiderDocumentOpen && (
          <RiderDocument documentId={documentId} isOpen={isReviewRiderDocumentOpen} onClose={documentDetails} />
        )
      }

      {
        isYesNoDialogOpen && (
          <ConfirmDialog isOpen={isYesNoDialogOpen} error={errorMessage} onYes={deleteUser} onNo={deleteRider} message={"Are you sure you want to  delete this user?"} />
        )
      }

    </Card>
  );
};

RidersTable.propTypes = {
  count: PropTypes.number,
  items: PropTypes.array,
  onDeselectAll: PropTypes.func,
  onDeselectOne: PropTypes.func,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  onSelectAll: PropTypes.func,
  onSelectOne: PropTypes.func,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  selected: PropTypes.array
};
